/** The ways a person asks for the same steps, so each one matches that how-to. */
export function askedHow(stem: string): string[] {
  return [
    `How do I ${stem}?`,
    `How can I ${stem}?`,
    `Where do I ${stem}?`,
    `I need to ${stem}`,
    `Help me ${stem}`,
  ];
}

/** The ways a person asks what something is, so each one matches that explanation. */
export function askedWhat(subject: string): string[] {
  return [
    `What is ${subject}?`,
    `Can you explain ${subject}?`,
    `I don't understand ${subject}`,
    `Tell me about ${subject}`,
    `What does ${subject} mean here?`,
    `Explain ${subject} please`,
  ];
}
